'use client'

import { Link } from 'react-router-dom'
import MUIStack from '@mui/material/Stack'
import { Logo } from '@repo/ui/Logo'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import { NavigationSidebarItem } from '../NavigationSidebarItem/NavigationSidebarItem'
import { CaseManagementIcon } from '@repo/ui/CaseManagementIcon'
import { ComplianceIcon } from '@repo/ui/ComplianceIcon'
import { AccountsIcon } from '@repo/ui/AccountsIcon'
import { ReportsIcon } from '@repo/ui/ReportsIcon'
import { SettingsIcon } from '@repo/ui/SettingsIcon'
import { ClockIcon } from '@repo/ui/ClockIcon'

export const NavigationSidebarItemsTop = () => {
  const color = 'white'
  const shift = 0
  const { sidebarMode } = useGlobalSettingsStore()

  return (
    <MUIStack direction={'column'} alignItems="center" data-testid="NavigationSidebarItemsTop">
      <Link to="/" title="Osprey" style={{ width: '100%', height: '52px' }}>
        <Logo showText={sidebarMode === 'expanded'} />
      </Link>

      <MUIStack direction={'column'} spacing={2} mt={5}>
        <NavigationSidebarItem
          label="Case management"
          menuKey="case-management"
          shift={shift}
          icon={<CaseManagementIcon sx={{ color }} />}
          menuItemId={1000}
          clickable
        />
        <NavigationSidebarItem
          label="Time recording"
          menuKey="time-recording"
          shift={shift}
          icon={<ClockIcon sx={{ color }} />}
          menuItemId={2200}
          clickable
        />
        <NavigationSidebarItem
          label="Compliance"
          menuKey="compliance"
          shift={shift}
          icon={<ComplianceIcon sx={{ color }} />}
          menuItemId={11000}
        />
        <NavigationSidebarItem
          label="Accounts"
          menuKey="accounts"
          shift={shift}
          icon={<AccountsIcon sx={{ color }} />}
          menuItemId={5000}
          clickable
        />
        <NavigationSidebarItem
          label="Reports"
          menuKey="reports"
          shift={shift}
          icon={<ReportsIcon sx={{ color }} />}
          menuItemId={4000}
        />
        <NavigationSidebarItem
          label="Supervisor"
          menuKey="supervisor"
          shift={shift}
          icon={<SettingsIcon sx={{ color }} />}
          menuItemId={9000}
        />
      </MUIStack>
    </MUIStack>
  )
}
